export default {
  getDataGroups: (state) => state.workflows.dataGroups,
  getMilestoneOptions: (state) => state.workflows.milestoneOptions,
  getWorkflows: (state) => state.workflows.workflows,
  getWorkflowDetails: (state) => state.workflows.workflowDetails,
  getPhases: (state) => state.workflows.phases,
};
